import { useQuery } from '@tanstack/react-query'
import { Building2 } from 'lucide-react'
import { Button, Card, CardBody, CardHeader, EmptyState } from '@akillidernek/ui'
import { api } from '../api'
import { setTenantSlug } from '../tenant-store'

/**
 * Dernek seçimi.
 *
 * Girişin yerini tutuyor: kullanıcı hangi dernek adına çalışacağını seçiyor.
 * Gerçek kimlik doğrulama ve kullanıcının yalnızca yetkili olduğu dernekleri
 * görmesi YES-84 ile gelecek.
 */
export function DernekSec() {
  const { data, isLoading } = useQuery({
    queryKey: ['me', 'tenants'],
    queryFn: async () => {
      const { data } = await api.GET('/api/v1/me/tenants')
      return data
    },
  })

  return (
    <div className="grid min-h-dvh place-items-center p-6">
      <Card className="w-[min(28rem,100%)]">
        <CardHeader title="Hangi dernek?" description="Yönetmek istediğiniz derneği seçin." />
        <CardBody>
          {isLoading ? (
            <p className="text-sm text-[var(--ad-text-muted)]">Yükleniyor…</p>
          ) : data && data.length > 0 ? (
            <ul className="flex flex-col gap-1">
              {data.map((tenant) => (
                <li key={tenant.id}>
                  <button
                    type="button"
                    onClick={() => setTenantSlug(tenant.slug)}
                    className="flex w-full items-center gap-3 rounded-[var(--radius-control)] px-3 py-2.5 text-left hover:bg-[var(--ad-surface-muted)]"
                  >
                    <Building2 className="size-4 text-[var(--ad-text-muted)]" />
                    <span className="min-w-0">
                      <span className="block truncate text-sm font-medium">{tenant.name}</span>
                      <span className="block text-xs text-[var(--ad-text-muted)]">
                        {tenant.slug}
                      </span>
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <EmptyState
              title="Hiçbir derneğe bağlı değilsiniz"
              description="Bir derneğe davet edildiğinizde burada görünecek."
              action={
                <Button size="sm" onClick={() => window.location.reload()}>
                  Yenile
                </Button>
              }
            />
          )}
        </CardBody>
      </Card>
    </div>
  )
}
